export default __webpack_public_path__ + "static/slider-image-3-8b65714bd047dff78fcaa21aab28902b.png";